var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 4,
    viewBox: "0 0 80 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.1768 2.17678C79.2744 2.07915 79.2744 1.92085 79.1768 1.82322L77.5858 0.232233C77.4882 0.134602 77.3299 0.134602 77.2322 0.232233C77.1346 0.329864 77.1346 0.488155 77.2322 0.585786L78.6464 2L77.2322 3.41421C77.1346 3.51184 77.1346 3.67014 77.2322 3.76777C77.3299 3.8654 77.4882 3.8654 77.5858 3.76777L79.1768 2.17678ZM0 2.25H79V1.75H0V2.25Z",
    fill: "#7A7A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.7242add546fad2d851bd0116eb529761.svg";
export { ForwardRef as ReactComponent };